/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ColorBtnClose[_ngcontent-%COMP%]{background-color:#a1a1a1!important}"];
export { styles as styles };
